import React, { useRef, useState } from "react";
import { RCCHookToast, RCCIcon, RCCServicesApi } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import HoursProjectsItem, { IHoursProjectsItem } from "./item";

export interface IHoursProjectsContainer{
    projectId: number;
}

const HoursProjectsContainer: React.FC<IHoursProjectsContainer> = ({
	projectId
}) => {
	

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
    
	const [data, setData] = useState<IHoursProjectsItem>();
	const timer = useRef<number>(0);

	const onMouseOverIcon = () => {
		timer.current = window.setTimeout(() => {
			getHours();
		}, 500);
	};

	const onMouseOutIcon = () => {
		window.clearTimeout(timer.current);
	};

	const getHours = async () => {
		try{
			const result = await RCCServicesApi.getRequest({
				method: "Project/GetHours",
				urlParameters: {id: projectId}
			});

			setData(result.data);
		}catch(err){
			standardErrorMessages(err, translate("Erro ao buscar dados de Horas de Projetos"), addToast);
		}
	};

	return(
		<>
			{
				data ? 
					<HoursProjectsItem hours={data} />

					: 

					<div onMouseOverCapture={onMouseOverIcon} onMouseOutCapture={onMouseOutIcon}>
						<RCCIcon 
							name="clock"
							size={14}
						/>
					</div>
			}
		</>
	);
};

export default HoursProjectsContainer;
